import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { UserCreateOrEditForm, NavBack } from '@/comp';
import { useStores } from '@/hooks/use-stores';
import { useParams } from 'react-router-dom';

const UserCreatePage = observer(() => {
  const { associableEntitiesStore, usersStore } = useStores();
  const { t } = useTranslation();
  const [isReady, setIsReady] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const params = useParams();

  useEffect(() => {
    // fetch associableEntitiesStore in case never fetched before
    !associableEntitiesStore.isReady && associableEntitiesStore.get();
  }, [associableEntitiesStore.isReady]);

  const onChangeDirty = value => {
    setIsDirty(value);
  };
  useEffect(() => {
    if (associableEntitiesStore.isReady) setIsReady(true);
  }, [associableEntitiesStore.isReady]);

  return (
    <Container>
      <NavBack
        url={`/home/station/${params.stationId}/settings/users`}
        popConfirmProps={
          isDirty
            ? {
                icon: null,
                placement: 'bottomRight',
                title: t('Changes will not be saved. Are you sure?'),
                okText: t('Discard changes'),
                cancelText: t('Dismiss'),
              }
            : undefined
        }
      />

      <div className="form-container">
        <UserCreateOrEditForm
          onChangeDirty={onChangeDirty}
          user={undefined}
          isReady={isReady && !usersStore.isLoading}
        />
      </div>
    </Container>
  );
});

const Container = styled.div`
  flex-grow: 1;
  overflow-x: auto;
  padding: ${({ theme: { token } }) => token.paddingMD}px;
  display: flex;
  flex-direction: column;

  header {
    h1 {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    }
  }

  .form-container {
    margin-top: ${({ theme: { token } }) => token.marginLG}px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
`;

export default UserCreatePage;
